var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[_c('div',{class:_vm.class_name(),staticStyle:{"width":"100%","margin-top":"5px"}},[_c('div',{class:_vm.class_bar(),style:('width: ' + _vm.val + '%'),attrs:{"data-percentage":_vm.val + '%'}})]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }